import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as routeBound from '../../route-bound'

import { getActionsConfig } from './actions'
import { Api } from './api.service'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Standalone feature for survey configuration state and effects, shared between
 * Space Full and Space Lite
 */
@ngCore.Injectable()
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link Api} */
  public readonly api = ngCore.inject(Api)

  constructor() {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'SpaceSurveyConfiguration',
      selectors: () => new Selectors(this),
    })

    const Context$ = ngCore.inject(routeBound.scenario.Context.TOKEN)

    this.registerEffects(
      effects.loadOnRequest(Context$),
      effects.upsertOnRequest(Context$),
      effects.loadOnScenarioContextChange(Context$),
      effects.reloadOnUpsertSuccess(),
    )
  }
}
